import { useState, useEffect, useRef } from 'react'
import { ColumnasReportes } from '../pages/reports/ColumnasReportes'

export const useReportColumnPreferences = (typeReportsSelected, tipo) => {
    const [columnas, setColumnas] = useState(ColumnasReportes)
    const [columnasParaMostrar, setColumnasParaMostrar] = useState([])
    const [widthTotal, setWidthTotal] = useState(0)

    // Track if we've loaded from localStorage to avoid overwriting on initial load
    const hasLoadedFromStorage = useRef(false)

    // Use a single global key for column preferences across all views
    const storageKey = 'global_report_columns_preferences_v2'

    // Load column preferences from localStorage
    useEffect(() => {
        const savedData = localStorage.getItem(storageKey)

        if (savedData) {
            try {
                const savedColumns = JSON.parse(savedData)
                // Merge saved preferences with master configuration
                const mergedColumns = ColumnasReportes.map(masterCol => {
                    const savedCol = savedColumns.find(sc => sc.id === masterCol.id)
                    // If user has a preference, use it. Otherwise default to TRUE (show all by default)
                    return savedCol
                        ? { ...masterCol, checked: savedCol.checked }
                        : { ...masterCol, checked: true }
                })
                setColumnas(mergedColumns)
            } catch (e) {
                console.error('Failed to parse column preferences', e)
                // Fallback: all checked by default
                setColumnas(ColumnasReportes.map(c => ({ ...c, checked: true })))
            }
        } else {
            // Initial state: Enable all columns by default
            const initialColumns = ColumnasReportes.map(col => ({
                ...col,
                checked: true
            }))
            setColumnas(initialColumns)
        }
        hasLoadedFromStorage.current = true
    }, [storageKey])

    useEffect(() => {
        // Filter columns for display based on current view restrictions
        const visibleColumns = columnas.filter(c => {
            // 1. Must be checked by user
            if (!c.checked) return false
            if (typeReportsSelected && typeReportsSelected !== 'all' && typeReportsSelected !== 'Todos' && c.restrict && !c.restrict.includes(typeReportsSelected)) return false

            return true
        })

        setColumnasParaMostrar(visibleColumns)

        let total = 0
        visibleColumns.forEach(col => {
            total += (col.width || 0) + 10
        })
        setWidthTotal(total > 0 ? total + 200 : 0)

        // Only save AFTER we've loaded from storage (not on initial render)
        if (hasLoadedFromStorage.current && columnas.length > 0) {
            const dataToSave = columnas.map(({ id, checked }) => ({ id, checked }))
            localStorage.setItem(storageKey, JSON.stringify(dataToSave))
        }
    }, [columnas, typeReportsSelected, storageKey])

    return {
        columnas,
        setColumnas,
        columnasParaMostrar,
        widthTotal
    }
}
